import { render, staticRenderFns } from "./ArtworkHistoryItem.vue?vue&type=template&id=840c5f90"
import script from "./ArtworkHistoryItem.vue?vue&type=script&lang=js"
export * from "./ArtworkHistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports